<template>
<div>
    

    <modal name="hello-world" :width="modal.width" height="auto" :adaptive="true" scrollable>

      <div class="grid edit ombrello w100">
        <div class="grid data h50">
        <!-- {{ombrellos}} -->
        <span v-if="$mq === 'sm'" class="close" v-on:click="hide()"><i class="fas fa-times-circle"></i></span>
        <el-form>
          <h1 v-on:click="changeombrid" v-if="!editombrid">{{ombrellos.ombrid}}</h1>
          <el-form-item>
            <el-input v-if="editombrid" v-model="ombrellos.ombrid"></el-input>
          </el-form-item>

          <!-- <div class="grid" style="grid-template-columns: 3fr 1fr; column; grid-column-gap: 12px;"> -->
          <el-form-item label="Nome ospite">
            <el-input placeholder="Nome ospite" v-model="ombrellos.guest"></el-input>
          </el-form-item>
          <el-form-item label="Camera">
            <el-input placeholder="Numero camera" v-model="ombrellos.room"></el-input>
          </el-form-item>
          <!-- </div> -->

          <p><strong>Arrivo e Partenza</strong></p>

          <!-- {{range}} {{hellorange}} {{disabledDates}} -->
          <!-- {{cashier}} -->
          <!-- {{ombrellos}} -->

          <!-- <DateRange class="calendar" :disabled-func="disabledFunc" :sync-range.sync="hellorange" :first-day-of-week="1" :lang="lang" @change="onChangedate" :emitChangeOnStep0="true" :dayClassFunc="dayClassFunc"></DateRange> -->
          <DateRange class="calendar" :sync-range.sync="hellorange" :first-day-of-week="1" :lang="lang" @change="onChangedate" :emitChangeOnStep0="true" :dayClassFunc="dayClassFunc"></DateRange>

          <!-- <el-date-picker
            v-model="hellorange"
            type="daterange"
            :picker-options="datePickerOptions"
            format="dd/MM/yyyy"
            range-separator="al"
            start-placeholder="Arrivo"
            end-placeholder="Partenza">
          </el-date-picker> -->

          <div class=" spacer sm"></div>
          <!-- <p><a v-on:click="updateombrello" v-if="!ombrellos.free" class="btn btn-green block">Update Ombrello</a></p> -->
          <!-- <el-form-item>
            <el-button v-if="!ombrellos.free" class="btn btn-green block" @click="updateombrello">Salve ombrellone</el-button>
            <el-button v-if="ombrellos.free" class="btn btn-green block" @click="saveOmbrello">Salva ombrellone</el-button>
          </el-form-item> -->
          <p><a v-on:click="updateombrello" v-if="!ombrellos.free" class="btn btn-green block">Salva Ombrello</a></p>
          <p><a v-on:click="saveOmbrello" v-if="ombrellos.free" class="btn btn-green block">Salva Ombrello</a></p>
          <div class=" spacer md"></div>
          <!-- <p><a v-on:click="closeombrello(ombrellos.guestnr)" class="btn btn-red block" v-if="!ombrellos.free">Cancella prenotazione</a></p> -->
        </el-form>
        </div>
        <div class="grid seats" :class="{ free : ombrellos.free }">
        <!-- {{ombrellos.passid}} -->
        <!-- {{ombrellos}} -->
        <!-- <button v-if="!ombrellos.passid && !ombrellos.free" type="button" class="btn btn-blue" v-on:click="generatePass"><i class="fas fa-qrcode"></i></button> -->
        <div class="grid qrcode">
          <div class="grid cash" v-if="hotel.cashier && ombrellos.cashable && hotel.seasons.length !== 0">
            <!-- <h2>Costo Ombrellone</h2> -->
            <span><small>Base</small>:</span>
            <span class="text-right"><small>€ {{cashier.tocash}}</small></span>
            <span><small>Extra</small>:</span>
            <span class="text-right"><small>€ {{cashier.extra}}</small></span>
            <span><strong>Totale:</strong></span>
            <span class="text-right"><strong>€ {{cashier.total}}</strong></span>
          </div>
          <qrcode v-if="ombrellos.passid && !ombrellos.free" :value="'https://spiaggia.ombrelleria.com/api/get/pass/' + ombrellos.passid" :options="{ width: 148 }"></qrcode>
        </div>
        <div class="note">
        <!-- {{ombrellos}} -->
        <el-form>
        <el-form-item v-if="sendPassForm">
          <el-input placeholder="email" v-model="guest.email"></el-input>
        </el-form-item>
        <el-form-item v-if="sendPassForm">
          <el-button class="btn btn-green block" @click="sendPass">manda beachpass</el-button>
        </el-form-item>
        <el-form-item label="Note">
          <el-input
            type="textarea"
            :rows="8"
            placeholder="Note"
            v-model="ombrellos.note">
          </el-input>
        </el-form-item>
        </el-form>
        </div>
        <div class="items">
          <div class="grid" v-for="item in ombrellos.items">     
            <span v-html="item.icon"></span>
            <span><a v-on:click="item.num -= 1"><span class="fa fa-minus-square"></span></a>{{item.num}}<a v-on:click="item.num += 1"><span class="fa fa-plus-square"></span></a></span>
          </div>
        </div> <!-- items -->
        </div>

        <div class="grid navi ombrellooptions" v-if="!ombrellos.free">

        <div class="grid shader">

          <div class="options">
            
            <!-- <el-tooltip class="item" effect="dark" content="Aggiungi oggetto spiaggia" placement="left-start">
              <el-button v-on:click="addbeachitem = true"><i class="fas fa-plus-square"></i></el-button>
            </el-tooltip> -->

            <el-tooltip v-if="!ombrellos.passid && !ombrellos.free" class="item" effect="dark" content="Crea Beachpass" placement="left-start">
              <el-button  type="button"  v-on:click="generatePass"><i class="fas fa-qrcode"></i></el-button>
            </el-tooltip>

            <el-tooltip v-if="ombrellos.passid && !ombrellos.free" class="item" effect="dark" content="manda beachpass tramite email" placement="left-start">
              <el-button type="button"  v-on:click="sendPassForm = true"><i class="fas fa-envelope"></i></el-button>
            </el-tooltip>

          </div>

          <div class="footer">
            
            <el-tooltip class="item" effect="dark" placement="left-start">
              <span slot="content">Cancella prenotazione</span>
              <el-button v-on:click="dialogVisibleOmbrello = true"><i class="fas fa-trash"></i></el-button>
            </el-tooltip>

          </div>

        </div>

        </div>

      </div>

    </modal>


    <el-dialog
      title="Attenzione"
      :visible.sync="dialogVisibleOmbrello"
      width="25%">
      <p>Sei sicuro di voler cancellare la prenotazione per {{ombrellos.ombrid}}?</p>
      <!-- <p>Tutti i dati verranno cancellati.</p> -->
      <span slot="footer" class="dialog-footer">
        <el-button class="btn btn-secondary" @click="dialogVisibleOmbrello = false">Anulla</el-button>
        <el-button class="btn btn-red" @click="closeombrello(ombrellos.guestnr)">Cancella</el-button>
      </span>
    </el-dialog>


  
</div>
</template>

<script>
  import Vue from 'vue'
  import {Circle4} from 'vue-loading-spinner'
  import datepicker from 'vue-date'
  import {DateRange} from 'vue-date-range'
  import Moment from 'moment'
  import { extendMoment } from 'moment-range'
  import 'moment/locale/de'
  import 'moment/locale/it'
  const moment = extendMoment(Moment)
  import Navbar from '@/components/Navbar'
  import { Drag, Drop } from 'vue-drag-drop'
  var host = process.env.ROOT_API
  export default {
    name: 'ombrelli',
    props: ['auth', 'authenticated', 'hotel', 'ombrellos', 'disabledDates', 'range'],
    data () {
      return {
        alphabet: ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'],
        letters: {
          first: 'A',
          last: '',
          act: 0,
          row: 1
        },
        value6: '',
        dialogVisibleOmbrello: false,
        sendPassForm: false,
        modal: {
          width: '70%',
          height: 'auto'
        },
        guest: {
          email: ''
        },
        beachitem: {
          name: '',
          icon: ''
        },
        addbeachitem: false,
        numbers: {
          first: 1,
          last: 0,
          act: 0
        },
        query: '',
        filtered: '',
        loading: false,
        nogrid: false,
        grid: {
          direction: '',
          letter: true,
          number: true,
          firststep: false,
          active: 0
        },
        state1: '',
        langs: [{
          lang: 'it'
        }, {
          lang: 'de'
        }],
        // hotel: '',
        secret: '',
        // pregrid: '',
        ombrelli: [],
        // hellorange: this.range,
        // range: {
        //   startDate: moment(),
        //   endDate: moment().add(1, 'days')
        // },
        style: '',
        rangestyle: '',
        hotelid: '',
        addombrello: {
          ombrid: ''
        },
        overview: {
          arrivals: [],
          departures: [],
          stays: []
        },
        date: ['2016-10-16', '2024-10-05'],
        today: moment().format('YYYY-MM-DD'),
        lang: 'it',
        rangepicker: [],
        rangeviewdata: '',
        // disabledRange: {
        //   startDate: moment(),
        //   endDate: moment().add(9, 'days')
        // },
        datePickerOptions: {
          firstDayOfWeek: 1,
          disabledDate: this.disabledFunc,
          onPick: this.onChangedate
        },
        firstDayOfWeek: 1,
        editombrid: false,
        dragging: null,
        lock: null,
        location: 'beach',
        rangeview: false
      }
    },
    components: {
      datepicker,
      Circle4,
      DateRange,
      'Navbar': Navbar,
      Drag,
      Drop
      // EmbeddedSlack
      // chat
    },
    sockets: {
      connect: function () {
        // console.log('socket connected')
      },
      stream: function (val) {
        // console.log('this method was fired by the socket server. eg: io.emit("customEmit", data)')
        // console.log(val.hotelid)
        if (val.hotelid === this.hotelid) {
          // console.log('an umbrella was updated')
          // this.getOmbrelli()
        }
      },
      disconnect: function () {
        // console.log('socket error')
        // this.$notify({
        //   group: 'foo',
        //   title: 'Error loading Data',
        //   text: 'I´ll fix it in a few',
        //   type: 'warning',
        //   duration: 5000
        // })
      }
    },
    methods: {
      dayClassFunc: function (dayMoment) {
        // console.log(dayMoment, moment(this.range.startDate._d).format('YYYY-MM-DD'))
          // this.disabledDates.forEach((date, index) => {
          //   if (true) {}
          // })
        // if (dayMoment.format('YYYY-MM-DD') === moment(this.range.startDate._d).format('YYYY-MM-DD')) {
        //   return ['today', 'important']
        // }
        if (this.disabledDates.includes(dayMoment.format('YYYY-MM-DD'))) {
          return ['ayou-day-cell', 'passive']
        }
      },
      emitVal () {
        const { date } = this
        // to support three ways to get value
        this.$emit('update:syncDate', date)
        this.$emit('input', date)
        this.$emit('change', date)
      },
      handleDayClick (day) {
        this.date = day.dayMoment
        this.emitVal()
      },
      getViewport () {
        // console.log(this.$mq)
        if (this.$mq === 'sm') {
          this.modal.width = '100%'
        } else {
          this.modal.width = '70%'
        }
      },
      updatebeachitems () {
        // console.log('add beachitem')
      },
      deletebeachitem (index) {
        // console.log(index)
        this.hotel.items.splice(index, 1)
      },
      stepHandler (e, i) {
        // console.log(e, i)
        this.grid.active = i
      },
      nextStep () {
        this.grid.active++
      },
      previousStep () {
        if (this.grid.active === 2) {
          this.ombrelli = []
          this.grid.direction = ''
          this.grid.active = 0
        } else {
          this.grid.active--
        }
      },
      filter (query) {
        // console.log(this.query, this.overview.arrivals.filter(item => item.ombrid === this.query))
        this.filtered = this.overview.arrivals.filter(item => item.guest.name === this.query)
      },
      // querySearch (queryString, cb) {
      //   var links = this.linkst
      //   var results = queryString ? links.filter(this.createFilter(queryString)) : links
      //   // call callback function to return suggestions
      //   console.log(results)
      //   cb(results)
      // },
      // createFilter (queryString) {
      //   return (link) => {
      //     // console.log(link, queryString)
      //     return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      //   }
      // },
      handleSelect (item) {
        // console.log(item)
      },
      disabledFunc (dayMoment) {
        // console.log(dayMoment)
        // console.log(dayMoment, moment(dayMoment).isBetween(moment('2019-04-03'), moment('2019-04-12')))
        // if (moment(dayMoment).isBetween(moment('2019-04-14'), moment('2019-04-24'))) {
        if (this.disabledDates.includes(moment(dayMoment).format('YYYY-MM-DD'))) {
          // console.log(moment(dayMoment).format('YYYY-MM-DD'))
          return true
        } else {
          // console.log(moment(dayMoment).format('YYYY-MM-DD'))
          return false
        }
      },
      // preCheckDate () {
      //   // console.log('ombrellos: ', this.ombrellos)
      //   // console.log(date)
      //   // console.log('preCheckDate')
      //   this.disabledDates = []
      //   this.ombrellos.guests.forEach((guest, indexo) => {
      //     // console.log(date, moment(date).isBetween(moment('2019-04-03'), moment('2019-04-12')))
      //     // console.log('guest: ', guest.name, 'ombrello guest: ', this.ombrellos.guest)
      //     if (guest.name !== this.ombrellos.guest) {
      //       var start = moment(guest.arrival, 'YYYY-MM-DD').add('days', 1)
      //       var end = moment(guest.departure, 'YYYY-MM-DD')
      //       // console.log('guest name: ', guest.name, 'start: ', start, 'end: ', end)
      //       var range = moment.range(start, end)
      //       var dates = Array.from(range.by('days', { excludeStart: true, excludeEnd: true })).map(m => m.format('YYYY-MM-DD'))
      //       // this.disabledDates = Array.from(range.by('days')).map(m => m.format('YYYY-MM-DD'))
      //       Array.prototype.push.apply(this.disabledDates, dates)
      //       // console.log('guest: ', guest.name, dates)
      //     }
      //   })
      // },
      // checkDate (date) {
        // console.log(moment(date).format('YYYY-MM-DD'))
        // date = moment(date).format('YYYY-MM-DD')
        // return moment(date).isBetween(moment(this.ombrellos.arrival), moment(this.ombrellos.departure))
        // console.log(date, moment(date).isBetween(moment('2019-04-03'), moment('2019-04-12')))
        // if (moment(date).isBetween(moment('2019-04-12'), moment('2019-04-14'))) {
        //   return true
        // } else {
        //   return false
        // }
        // this.ombrellos.guests.forEach(function (guest, indexo) {
        //   console.log(date, moment(date).isBetween(moment('2019-04-03'), moment('2019-04-12')))
        //   if (moment(date).isBetween(moment('2019-04-03'), moment('2019-04-12'))) {
        //     return true
        //   } else {
        //     return false
        //   }
        // })
      // },
      handleDragover (group, data, event) {
        // console.log(data)
        // console.log(group.ombrid)
        // console.log(event)
        if (!group.free) {
          event.dataTransfer.dropEffect = 'none'
        }
      },
      handleDrop (group, data, key) {
        // console.log(group.ombrello.ombrid, data.target.id)
        this.moveombrello(group.ombrello, data.target.id)
        // alert(`You dropped with data: ${JSON.stringify(data)}`)
      },
      changeombrid () {
        // console.log('changeombrid')
        this.editombrid = true
      },
      onChangedate (range) {
        // this.range = range
        // console.log(range)
        this.$emit('changeOmbrellodate', range)
        // console.log('hello-world onChange: ', moment(range.endDate._d))
      },
      // setRange (p) {
      //   if (typeof p === 'number') {
      //     console.log(p)
      //     // this.$emit()
      //     this.range = {
      //       startDate: moment().add(p, 'days'),
      //       endDate: moment()
      //     }
      //   }
      // },
      // show (ombrello) {
      //   console.log(ombrello.arrival)
      //   this.ombrellos = ombrello
      //   if (ombrello.free) {
      //     this.ombrellos.chairs = this.hotel.chairs
      //     this.ombrellos.beds = this.hotel.beds
      //   }
      //   // if (ombrello.beds === null) { this.ombrellos.beds = this.hotel.beds }
      //   this.date[0] = ombrello.arrival
      //   this.date[1] = ombrello.departure
      //   // console.log('arrival ', moment(ombrello.arrival, 'DD.MM.YYYY'))
      //   if (ombrello.arrival) {
      //     console.log('show ombrello arrival: ', moment(ombrello.arrival).format('DD.MM.YYYY'))
      //     this.range.startDate = moment(ombrello.arrival)
      //   }
      //   if (ombrello.departure) {
      //     this.range.endDate = moment(ombrello.departure)
      //   }
      //   this.preCheckDate()
      //   this.$modal.show('hello-world')
      // },
      hide () {
        this.$modal.hide('hello-world')
      },
      // settings () {
      //   this.$modal.show('settings')
      // },
      // updatehotel: function () {
      //   this.$http
      //     .post(host + '/api/updatehotel', { hotel: this.hotel },
      //     {
      //       headers: {
      //         'Authorization': 'Bearer ' + localStorage.jwt
      //       }
      //     },
      //     ).then((data) => {
      //       // this.ombrelli = data.body.ombrells
      //       console.log(data)
      //       this.$modal.hide('settings')
      //       // this.getOmbrelli()
      //     }, (error) => {
      //       console.log(error)
      //       this.$notify({
      //         group: 'foo',
      //         title: 'Error loading Data',
      //         text: 'I´ll fix it in a few',
      //         type: 'warning',
      //         duration: 500
      //       })
      //     })
      // },
      sendPass () {
        // console.log('pass email: ', this.guest.email)
        this.$http
          .post(host + '/api/pass/send', { ombrellos: this.ombrellos, hotel: this.hotel, email: this.guest.email },
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            // console.log(data)
            this.$notify({
              group: 'foo',
              title: 'Beachpass mandato a ' + this.guest.email,
              type: 'success',
              duration: 500
            })
            this.sendPassForm = false
          }, (error) => {
            console.log(error)
            this.$notify({
              group: 'foo',
              title: 'Error loading Data',
              text: 'I´ll fix it in a few',
              type: 'warning',
              duration: 500
            })
          })
      },
      generatePass () {
        // console.log('pass: ', this.hotel)
        this.$http
          .post(host + '/api/generatepass', { ombrellos: this.ombrellos, hotel: this.hotel },
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            // console.log(data)
            if (!this.ombrellos.passid) {
              this.ombrellos.passid = data.body.passid
            } else {
              this.ombrellos.passid = data.body.passid
              this.updateombrello()
            }
            // this.ombrellos.guestsinday[0].passid = data.body.passid
            // this.$modal.hide('hello-world')
            // this.getOmbrelli()
          }, (error) => {
            console.log(error)
            this.$notify({
              group: 'foo',
              title: 'Error loading Data',
              text: 'I´ll fix it in a few',
              type: 'warning',
              duration: 500
            })
          })
      },
      updatePass (passid) {
        // console.log('passid: ', passid)
        this.$http
          .post(host + '/api/pass/update', { ombrellos: this.ombrellos, passid: passid },
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            // console.log(data)
            // this.ombrellos.passid = data.body.passid
            // this.updateombrello()
            // this.ombrellos.guestsinday[0].passid = data.body.passid
            // this.$modal.hide('hello-world')
            // this.getOmbrelli()
          }, (error) => {
            console.log(error)
            this.$notify({
              group: 'foo',
              title: 'Error loading Data',
              text: 'I´ll fix it in a few',
              type: 'warning',
              duration: 500
            })
          })
      },
      saveOmbrello: function () {
        console.log(this.ombrellos)
        this.ombrellos.arrival = moment(this.range.startDate._d).format('YYYY-MM-DD')
        if (this.hotel.singledaybooking && this.range.startDate._d === this.range.endDate._d) {
          console.log('same day')
          this.ombrellos.departure = moment(this.range.startDate._d).format('YYYY-MM-DD')
        } else {
          this.ombrellos.departure = moment(this.range.endDate._d).format('YYYY-MM-DD')
        }
        // console.log(this.range['endDate'])
        this.$http
          .post(host + '/api/generatepass', { ombrellos: this.ombrellos, hotel: this.hotel },
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            console.log('second: ', this.ombrellos)
            this.ombrellos.passid = data.body.passid
            // this.updateombrello()
            // this.ombrellos.guestsinday[0].passid = data.body.passid
            // this.$modal.hide('hello-world')
            // this.getOmbrelli()
            this.$delete(this.ombrellos, '__v')
            // this.ombrellos.arrival = moment(this.range.startDate._d).format('YYYY-MM-DD')
            // this.ombrellos.departure = moment(this.range.endDate._d).format('YYYY-MM-DD')
            this.editombrid = false
            this.ombrellos.guests.push({name: this.ombrellos.guest, room: this.ombrellos.room, arrival: this.ombrellos.arrival, departure: this.ombrellos.departure, items: this.ombrellos.items, note: this.ombrellos.note, passid: this.ombrellos.passid})
            this.ombrellos.guest = ''
            this.ombrellos.note = ''
            this.ombrellos.room = ''
            this.ombrellos.arrival = ''
            this.ombrellos.departure = ''
            // this.ombrellos.passid = ''
            this.ombrellos.guestsinday = []
            this.ombrellos.free = true
            // console.log('ombrello: ', this.ombrellos.ombrid, this.ombrellos.guests)
            this.$http
              .post(host + '/api/updateombrello', { ombrellos: this.ombrellos },
              {
                headers: {
                  'Authorization': 'Bearer ' + localStorage.jwt
                }
              },
              ).then((data) => {
                console.log(data)
                this.$modal.hide('hello-world')
                // this.getOmbrelli()
              }, (error) => {
                console.log(error)
                this.$notify({
                  group: 'foo',
                  title: 'Error loading Data',
                  text: 'I´ll fix it in a few',
                  type: 'warning',
                  duration: 500
                })
              })
          }, (error) => {
            console.log(error)
            this.$notify({
              group: 'foo',
              title: 'Error loading Data',
              text: 'I´ll fix it in a few',
              type: 'warning',
              duration: 500
            })
          })
      },
      updateombrello () {
        console.log(this.ombrellos)
        // console.log(this.range['endDate'])
        var passid = this.ombrellos.passid
        var passombrello = this.ombrellos
        this.$delete(this.ombrellos, '__v')
        this.ombrellos.arrival = moment(this.range.startDate._d).format('YYYY-MM-DD')
        if (this.hotel.singledaybooking && this.range.startDate._d === this.range.endDate._d) {
          this.ombrellos.departure = moment(this.range.startDate._d).format('YYYY-MM-DD')
        } else {
          this.ombrellos.departure = moment(this.range.endDate._d).format('YYYY-MM-DD')
        }
        this.editombrid = false
        // this.ombrellos.guests.push({name: this.ombrellos.guest, room: this.ombrellos.room, arrival: this.ombrellos.arrival, departure: this.ombrellos.departure})
        if (this.ombrellos.free) {
          console.log(this.ombrellos.guests[this.ombrellos.guestnr] + ' is free so i am not updating guest data')
          // this.ombrellos.guests = {name: this.ombrellos.guest, room: this.ombrellos.room, arrival: this.ombrellos.arrival, departure: this.ombrellos.departure}
        } else {
          this.ombrellos.guests[this.ombrellos.guestnr] = {name: this.ombrellos.guest, room: this.ombrellos.room, arrival: this.ombrellos.arrival, departure: this.ombrellos.departure, items: this.ombrellos.items, note: this.ombrellos.note, passid: this.ombrellos.passid}
        }
        // this.ombrellos.guest = ''
        // this.ombrellos.note = ''
        // this.ombrellos.room = ''
        // this.ombrellos.arrival = ''
        // this.ombrellos.departure = ''
        // this.ombrellos.passid = ''
        this.ombrellos.guestsinday = []
        this.ombrellos.free = true
        // console.log('ombrello update: ', this.ombrellos, passid, passombrello)
        this.$http
          .post(host + '/api/updateombrello', { ombrellos: this.ombrellos, passid: passid, passombrello: passombrello },
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            // console.log(data)
            this.$modal.hide('hello-world')
            this.updatePass(passid)
            // this.getOmbrelli()
          }, (error) => {
            console.log(error)
            this.$notify({
              group: 'foo',
              title: 'Error loading Data',
              text: 'I´ll fix it in a few',
              type: 'warning',
              duration: 500
            })
          })
      },
      moveombrello: function (old, newo) {
        // console.log(old, newo)
        // this.ombrellos = old
        // this.closeombrello()
        // old._id = newo
        // old.ombrid = ombrid
        // console.log(this.ombrellos)
        // this.ombrellos = newo
        this.$http
          .post(host + '/api/moveombrello', { old: old, newo: newo },
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            // console.log(data)
            this.dragging = null
            // this.getOmbrelli()
          }, (error) => {
            console.log(error)
            this.$notify({
              group: 'foo',
              title: 'Error loading Data',
              text: 'I´ll fix it in a few',
              type: 'warning',
              duration: 500
            })
          })
      },
      closeombrello (index) {
        // console.log(this.ombrellos.guests, index)
        this.dialogVisibleOmbrello = false
        var passid = this.ombrellos.passid
        this.ombrellos.guests.splice(index, 1)
        // console.log('updated: ', this.ombrellos.guests)
        this.ombrellos.guest = ''
        this.ombrellos.room = ''
        this.ombrellos.arrival = ''
        this.ombrellos.departure = ''
        this.ombrellos.free = true
        this.ombrellos.guestsinday = []
        this.$http
          .post(host + '/ombrelloni/close', { ombrellos: this.ombrellos },
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            // console.log(data)
            this.$modal.hide('hello-world')
            this.updatePass(passid)
            // this.getOmbrelli()
          }, (error) => {
            console.log(error)
          })
      },
      addombrell: function () {
        // console.log(this.addombrello, this.hotelid)
        this.$http
          // .get('http://srv5.ghosted.it:8000/authorized',
        // var ombrellos = this.ombrellos
          .post(host + '/ombrelloni/add', { ombrid: this.addombrello.ombrid, hotelid: this.hotelid, location: this.location },
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            // this.ombrelli = data.body.ombrells
            // console.log(data)
            // this.getOmbrelli()
          }, (error) => {
            console.log(error)
          })
      },
      editguest: function (index) {
        // console.log(index.ombrid, index.edit)
        index.edit = true
        // Vue.set(this.ombrelli[index], 'edit', true)
      },
      saveEdit: function (index, guest) {
        // save your changes
        // this.toggleEdit(index, guest)
        // console.log(index, guest)
        Vue.set(this.ombrelli[index], 'guest', guest)
      },
      // presetGrid () {
      //   var grid = this.hotel.cols * this.hotel.rows
      //   if (this.ombrelli.length === grid) {
      //     console.log('preset grid done')
      //   } else {
      //     console.log('preset grid not yet done')
      //     if (this.numbers.first < 10) {
      //       this.pregrid = {
      //         first: {
      //           letter: this.letters.first,
      //           number: '0' + this.numbers.first
      //         },
      //         left: {
      //           letter: this.letters.first,
      //           number: '0' + this.numbers.first
      //         },
      //         up: {
      //           letter: this.letters.first,
      //           number: '0' + this.numbers.first
      //         }
      //       }
      //     } else {
      //       this.pregrid = {
      //         first: {
      //           letter: this.letters.first,
      //           number: this.numbers.first
      //         },
      //         left: {
      //           letter: this.letters.first,
      //           number: this.numbers.first
      //         },
      //         up: {
      //           letter: this.letters.first,
      //           number: this.numbers.first
      //         }
      //       }
      //     }
      //   }
      // },
      resetGrid () {
        this.ombrelli = []
        this.grid.firststep = true
        this.letters.act = this.alphabet.indexOf(this.letters.first.toLowerCase())
        this.letters.row = 1
        this.numbers.act = this.numbers.first
        this.grid.active = 2
        if (this.letters.first.length === 0 || this.grid.direction === 'empty') {
          this.setemptyGrid()
        } else {
          this.setGrid()
        }
      },
      setemptyGrid () {
        var grid = this.hotel.cols * this.hotel.rows
        // console.log('ombrelli length', (this.ombrelli.length + 1), 'numbers act: ', this.numbers.act)
        if (this.ombrelli.length === grid) {
          // console.log('done')
        } else {
          if (grid > 99 && this.numbers.act <= 9) {
            // console.log('case: 1')
            this.ombrelli.push({ombrid: '00' + (parseInt(this.numbers.act)), free: true})
            this.numbers.act++
          } else if (grid > 99 && this.numbers.act <= 99) {
            // console.log('case: 2')
            this.ombrelli.push({ombrid: '0' + (parseInt(this.numbers.act)), free: true})
            this.numbers.act++
          } else {
            // console.log('case: 3')
            this.ombrelli.push({ombrid: (parseInt(this.numbers.act)), free: true})
            this.numbers.act++
          }
          this.setemptyGrid()
        }
      },
      setGrid () {
        var grid = this.hotel.cols * this.hotel.rows
        // console.log(this.letters.first)
        if (this.letters.act === this.alphabet.length) {
          this.letters.act = 0
        }
        var act = this.alphabet[this.letters.act].toUpperCase()
        // console.log('act: ', act, this.numbers.act)
        if (this.ombrelli.length === grid) {
          // console.log('done')
        } else {
          // console.log('not done')
          if (this.numbers.act < 10) {
            this.ombrelli.push({ombrid: act + '0' + this.numbers.act, free: true})
            // console.log('nr: ', act + '0' + this.numbers.act)
            if (this.grid.direction === 'left') {
              this.numbers.act++
            } else {
              this.letters.act++
            }
            if (this.ombrelli.length === (this.hotel.cols * this.letters.row)) {
              if (this.grid.direction === 'left') {
                this.numbers.act = this.numbers.first
                this.letters.row++
                this.letters.act++
              } else {
                this.letters.act = this.alphabet.indexOf(this.letters.first.toLowerCase())
                this.numbers.act++
                this.letters.row++
              }
              // console.log('end of row', this.letters.row - 1, this.numbers.act)
            } else {}
            this.setGrid()
          } else {
            this.ombrelli.push({ombrid: act + this.numbers.act, free: true})
            // console.log('nr: ', act + this.numbers.act)
            if (this.grid.direction === 'left') {
              this.numbers.act++
            } else {
              this.letters.act++
            }
            if (this.ombrelli.length === (this.hotel.cols * this.letters.row)) {
              if (this.grid.direction === 'left') {
                this.numbers.act = this.numbers.first
                this.letters.row++
                this.letters.act++
              } else {
                this.letters.act = this.alphabet.indexOf(this.letters.first.toLowerCase())
                this.numbers.act++
                this.letters.row++
              }
              // console.log('end of row', this.letters.row - 1, this.numbers.act)
            } else {}
            this.setGrid()
          }
          // if (this.numbers.first < 10) {
          //   this.ombrelli.push({ombrid: act + '0' + this.numbers.first, free: true})
          //   this.letters.act = this.alphabet.indexOf(act) + 1
          //   if (this.ombrelli.length === (this.hotel.cols * this.letters.row)) {
          //     this.letters.act = 0
          //     this.letters.row = this.letters.row + 1
          //   }
          //   this.setGrid()
          // } else {
          //   this.ombrelli.push({ombrid: act + this.numbers.first, free: true})
          //   this.letters.act = this.alphabet.indexOf(act) + 1
          //   if (this.ombrelli.length === (this.hotel.cols * this.letters.row)) {
          //     this.letters.act = 0
          //     this.letters.row = this.letters.row + 1
          //   }
          //   this.setGrid()
          // }
        }
        // var grid = this.hotel.cols * this.hotel.rows
        // console.log(this.letters.first)
        // var act = this.alphabet[this.letters.act]
        // console.log('act: ', act)
        // if (this.ombrelli.length === grid) {
        //   console.log('done')
        // } else {
        //   console.log('not done')
        //   if (this.hotel.rows > 10 && this.letters.row < 10) {
        //     this.ombrelli.push({ombrid: act + '0' + this.letters.row, free: true})
        //     this.letters.act = this.alphabet.indexOf(act) + 1
        //     if (this.ombrelli.length === (this.hotel.cols * this.letters.row)) {
        //       this.letters.act = 0
        //       this.letters.row = this.letters.row + 1
        //     }
        //     this.setGrid()
        //   } else {
        //     this.ombrelli.push({ombrid: act + this.letters.row, free: true})
        //     this.letters.act = this.alphabet.indexOf(act) + 1
        //     if (this.ombrelli.length === (this.hotel.cols * this.letters.row)) {
        //       this.letters.act = 0
        //       this.letters.row = this.letters.row + 1
        //     }
        //     this.setGrid()
        //   }
        // }
      },
      // saveGrid: function () {
      //   console.log(this.ombrelli)
      //   this.$http
      //     .post(host + '/api/savegrid', { hotel: this.hotel, ombrelli: this.ombrelli },
      //     {
      //       headers: {
      //         'Authorization': 'Bearer ' + localStorage.jwt
      //       }
      //     },
      //     ).then((data) => {
      //       console.log(data)
      //       this.getOmbrelli()
      //       this.nogrid = false
      //     }, (error) => {
      //       console.log(error)
      //       this.$notify({
      //         group: 'foo',
      //         title: 'grid saved',
      //         type: 'success',
      //         duration: 500
      //       })
      //     })
      // },
      // changeDate () {
      //   console.log(moment(this.today).format('YYYY-MM-DD'))
      //   this.today = moment(this.today).format('YYYY-MM-DD')
      //   this.getOmbrelli()
      //   this.rangeview = false
      // },
      // changeRange () {
      //   // console.log(moment(this.rangepicker).format('YYYY-MM-DD'))
      //   var start = moment(this.rangepicker[0], 'YYYY-MM-DD')
      //   var end = moment(this.rangepicker[1], 'YYYY-MM-DD')
      //   var range = moment.range(start, end)
      //   var dates = Array.from(range.by('days')).map(m => m.format('YYYY-MM-DD'))
      //   // console.log('range picker dates: ', dates)
      //   this.rangestyle = 'grid-template-rows: repeat(' + dates.length + ', 1fr);'
      //   this.rangeviewdata = dates
      //   this.rangeview = true
      //   this.ombrelli.forEach((ombrello, indexo) => {
      //     // console.log('ombrello: ', ombrello)
      //     // this.ombrelli.push(ombrello)
      //     Vue.set(this.ombrelli[indexo], 'dates', [])
      //     // ombrello.guests.forEach((guest, index) => {
      //       // console.log('guest: ', guest)
      //       // console.log(moment(this.today).isBetween(guest.arrival, guest.departure))
      //     dates.forEach((date, indexd) => {
      //       this.ombrelli[indexo].dates.push({date: moment(date).format('DD/MM'), day: moment(date).format('dd'), guests: [], free: true})
      //       ombrello.guests.forEach((guest, index) => {
      //         if (moment(date).isBetween(guest.arrival, guest.departure, null, '[]')) {
      //           console.log(ombrello.ombrid + ' is occupied on ' + date)
      //           // this.ombrelli[indexo].dates.push({date: date, guest: guest})
      //           this.ombrelli[indexo].dates[indexd].guests.push(guest)
      //           this.ombrelli[indexo].dates[indexd].free = false
      //         } else {
      //           // console.log(ombrello.ombrid + ' is free on ' + this.today)
      //           console.log(ombrello.ombrid + ' is free on ' + date)
      //           // this.ombrelli[indexo].free = true
      //           // this.ombrelli[indexo].dates.push({date: date, guest: guest})
      //         }
      //       })
      //     })
      //   })
      // },
      // getOmbrelli () {
      //   this.$http
      //     .post(host + '/ombrelloni/all', { hotelid: this.$route.params.hotel },
      //     {
      //       headers: {
      //         'Authorization': 'Bearer ' + localStorage.jwt
      //       }
      //     },
      //     ).then((data) => {
      //       console.log('hotel: ', data.body.ombrells)
      //       // this.hotelid = data.body.hotels._id
      //       // this.hotel = data.body.hotels
      //       moment.locale(data.body.hotels.lang)
      //       if (data.body.hotels.chairs === undefined) {
      //         this.hotel.chairs = 1
      //       }
      //       if (data.body.hotels.beds === undefined) {
      //         this.hotel.beds = 1
      //       }
      //       this.style = 'grid-template-columns: repeat(' + data.body.hotels.cols + ', 1fr); grid-template-rows: repeat(' + data.body.hotels.rows + ', auto);'
      //       console.log('hotel: ' + this.hotelid)
      //       console.log(data)
      //       this.ombrelli = data.body.ombrells
      //       console.log(this.today)
      //       this.ombrelli = []
      //       data.body.ombrells.forEach((ombrello, indexo) => {
      //         this.ombrelli.push(ombrello)
      //         ombrello.guests.forEach((guest, index) => {
      //           console.log('guest: ', guest)
      //           if (moment(this.today).isBetween(guest.arrival, guest.departure, null, '[]')) {
      //             console.log(ombrello.ombrid + ' is occupied between ' + guest.arrival + ' and ' + guest.departure)
      //             this.ombrelli[indexo].guest = guest.name
      //             this.ombrelli[indexo].room = guest.room
      //             this.ombrelli[indexo].arrival = guest.arrival
      //             this.ombrelli[indexo].departure = guest.departure
      //             this.ombrelli[indexo].free = false
      //             this.ombrelli[indexo].guestnr = index
      //             this.ombrelli[indexo].guestsinday.push(guest)
      //           } else {
      //           }
      //         })
      //       })
      //       this.getOverview()
      //       if (data.body.ombrells <= 0) {
      //         this.nogrid = true
      //       }
      //       this.loading = false
      //     }, (error) => {
      //       console.log(error)
      //       this.$router.replace('/')
      //     })
      // },
      // getOverview () {
      //   this.overview.arrivals = []
      //   this.overview.departures = []
      //   this.overview.stays = []
      //   this.ombrelli.forEach((ombrello, indexo) => {
      //     // console.log('ombrello: ', ombrello)
      //     // this.ombrelli.push(ombrello)
      //     ombrello.guests.forEach((guest, index) => {
      //       console.log('guest: ', guest)
      //       // console.log(moment(this.today).isBetween(guest.arrival, guest.departure))
      //       if (moment(this.today).isSame(guest.arrival)) {
      //       // if (moment('2019-04-06').isBetween('2019-04-03', '2019-04-10')) {
      //         console.log(ombrello.ombrid + ' is coming today: ' + guest.arrival)
      //         this.overview.arrivals.push({guest: guest, ombrid: ombrello.ombrid})
      //       } else if (moment(this.today).isSame(guest.departure)) {
      //       // if (moment('2019-04-06').isBetween('2019-04-03', '2019-04-10')) {
      //         console.log(ombrello.ombrid + ' is starting today: ' + guest.departure)
      //         this.overview.departures.push({guest: guest, ombrid: ombrello.ombrid})
      //       } else if (moment(this.today).isBetween(guest.arrival, guest.departure, null, '()')) {
      //         console.log(ombrello.ombrid + ' is staying here today: ' + guest.departure)
      //         this.overview.stays.push({guest: guest, ombrid: ombrello.ombrid})
      //       }
      //     })
      //   })
      // },
      addchair (index, nr, chair, hotel) {
        // console.log(this.ombrelli)
        // console.log(index, chair, hotel)
        var newchairs = nr + 1
        this.$http
          .post(host + '/api/addchair/' + chair, {chairid: chair, hotelid: hotel},
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            // console.log(data)
            // this.loading = false
            Vue.set(this.ombrelli[index], 'chairs', newchairs)
            this.$notify({
              group: 'foo',
              title: 'Chair added',
              type: 'success',
              duration: 500
            })
          }, (error) => {
            console.log(error)
          })
      },
      removechair (index, nr, chair, hotel) {
        // console.log(this.ombrelli)
        // console.log(index, chair, hotel)
        var newchairs = nr - 1
        this.$http
          .post(host + '/api/removechair/' + chair, {chairid: chair, hotelid: hotel},
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            // console.log(data)
            // this.loading = false
            Vue.set(this.ombrelli[index], 'chairs', newchairs)
          }, (error) => {
            console.log(error)
          })
      },
      addbed (index, nr, chair, hotel) {
        // console.log(this.ombrelli)
        // console.log(index, chair, hotel)
        var newchairs = nr + 1
        this.$http
          .post(host + '/api/addbed/' + chair, {chairid: chair, hotelid: hotel},
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            console.log(data)
            // this.loading = false
            Vue.set(this.ombrelli[index], 'beds', newchairs)
          }, (error) => {
            console.log(error)
          })
      },
      removebed (index, nr, chair, hotel) {
        // console.log(this.ombrelli)
        // console.log(index, chair, hotel)
        var newchairs = nr - 1
        this.$http
          .post(host + '/api/removebed/' + chair, {chairid: chair, hotelid: hotel},
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            console.log(data)
            // this.loading = false
            Vue.set(this.ombrelli[index], 'beds', newchairs)
          }, (error) => {
            console.log(error)
          })
      }
      // changeguest (index, chair, guest) {
      //   // console.log(this.ombrelli)
      //   // console.log(index, chair, guest)
      //   // var newchairs = nr - 1
      //   // this.$http
      //   //   .post(host + '/api/removebed/' + chair, {chairid: chair, hotelid: hotel},
      //   //   {
      //   //     headers: {
      //   //       'Authorization': 'Bearer ' + localStorage.jwt
      //   //     }
      //   //   },
      //   //   ).then((data) => {
      //   //     console.log(data)
      //   //     // this.loading = false
      //   //     Vue.set(this.ombrelli[index], 'beds', newchairs)
      //   //   }, (error) => {
      //   //     console.log(error)
      //   //   })
      // }
    },
    beforeMount () {
      // this.getOmbrelli()
      // this.getViewport()
      // this.letters.act = this.alphabet.indexOf(this.letters.first)
    },
    mounted: function () {
      // this.getOverview()
      this.getViewport()
      // moment.locale(this.hotel.lang)
      // console.log('hotel: ', this.hotel)
    },
    computed: {
      cashier () {
        var tocash = 0
        var extra = 0
        var start = moment(this.hellorange.startDate)
        // var end = moment(this.hellorange.endDate)
        var end = this.hotel.singledaybooking ? moment(this.hellorange.endDate) : moment(this.hellorange.endDate).subtract(1, 'days')
        var range = moment.range(start, end)
        var dates = Array.from(range.by('days')).map(m => m.format('YYYY-MM-DD'))
        // console.log('dates: ', dates)
        console.log('ombrellos: ', this.ombrellos)
        dates.forEach((date, index) => {
          // console.log(date)
          this.ombrellos.seasons.forEach((season, index) => {
            // console.log(season)
            if (moment(date).isBetween(season.start, season.end, null, '[]')) {
              // console.log(date + 'is in ' + season.name, season.amount)
              this.ombrellos.items.forEach((item, index) => {
                // console.log(item)
                extra = parseInt(extra) + (parseInt(item.num) * parseInt(season.items[index].price))
              })
              tocash = parseInt(tocash) + parseInt(season.amount)
            }
          })
        })
        return {
          tocash: tocash.toFixed(2),
          extra: extra.toFixed(2),
          total: (parseInt(tocash) + parseInt(extra)).toFixed(2)
        }
      },
      modalWidth () {
        // console.log(this.$mq)
        if (this.$mq === 'sm') {
          return '100%'
        } else if (this.$mq === 'md') {
          return '80%'
        } else {
          return '50%'
        }
      },
      hellorange: {
        get () {
          // console.log(this.range)
          return Object.assign({}, this.range)
          // return [moment(this.range.startDate).format('YYYY-MM-DD'), moment(this.range.endDate).format('YYYY-MM-DD')]
        },
        set (newValue) {
          console.log(newValue)
        }
      },
      hotelgrid: function () {
      // `this` points to the vm instance
        this.numbers.last = this.hotel.cols * this.hotel.rows
        return this.hotel.cols * this.hotel.rows
      },
      state: function () {
        // console.log('today: ', this.today)
      },
      filteredArrivals () {
        console.log('filteredArrivals')
        return this.overview.arrivals.filter(post => {
          var arrivals = post.guest.name.toLowerCase().includes(this.query.toLowerCase())
          var arrivalsroom = post.guest.room.toLowerCase().includes(this.query.toLowerCase())
          console.log(arrivals)
          if (arrivals) {
            return arrivals
          } else {
            return arrivalsroom
          }
        })
      },
      filteredDepartures () {
        return this.overview.departures.filter(post => {
          var departures = post.guest.name.toLowerCase().includes(this.query.toLowerCase())
          var departuresroom = post.guest.room.toLowerCase().includes(this.query.toLowerCase())
          if (departures) {
            return departures
          } else {
            return departuresroom
          }
        })
      },
      filteredStays () {
        return this.overview.stays.filter(post => {
          var stays = post.guest.name.toLowerCase().includes(this.query.toLowerCase())
          var staysroom = post.guest.room.toLowerCase().includes(this.query.toLowerCase())
          if (stays) {
            return stays
          } else {
            return staysroom
          }
        })
      },
      pregrid () {
        var next = this.alphabet.indexOf(this.letters.first.toLowerCase()) + 1
        if (this.letters.first.length > 0) {
          if (this.numbers.first < 10) {
            return { first: { letter: this.letters.first.toUpperCase(), number: '0' + this.numbers.first }, left: { letter: this.letters.first.toUpperCase(), number: '0' + (parseInt(this.numbers.first) + 1) }, up: { letter: this.alphabet[next].toUpperCase(), number: '0' + this.numbers.first }, upleft: { letter: this.alphabet[next].toUpperCase(), number: '0' + (parseInt(this.numbers.first) + 1) } }
          } else {
            return { first: { letter: this.letters.first.toUpperCase(), number: this.numbers.first }, left: { letter: this.letters.first.toUpperCase(), number: (parseInt(this.numbers.first) + 1) }, up: { letter: this.alphabet[next].toUpperCase(), number: this.numbers.first }, upleft: { letter: this.alphabet[next].toUpperCase(), number: (parseInt(this.numbers.first) + 1) } }
          }
        } else {
          console.log('no letter', this.hotel.cols)
          if (this.numbers.first < 10) {
            return { first: { letter: this.letters.first.toUpperCase(), number: '0' + this.numbers.first }, left: { letter: this.letters.first.toUpperCase(), number: '0' + (parseInt(this.numbers.first) + 1) }, up: { letter: this.alphabet[next].toUpperCase(), number: '0' + this.numbers.first }, upleft: { letter: this.alphabet[next].toUpperCase(), number: '0' + (parseInt(this.numbers.first) + 1) } }
          } else {
            return { first: { letter: this.letters.first.toUpperCase(), number: this.numbers.first }, left: { letter: this.letters.first.toUpperCase(), number: (parseInt(this.numbers.first) + 1) }, up: { letter: this.alphabet[next].toUpperCase(), number: (this.hotel.cols + 1) }, upleft: { letter: this.alphabet[next].toUpperCase(), number: (parseInt(this.hotel.cols) + 1) } }
          }
        }
      }
    }
  }
</script>

<style>
  a {
    cursor: pointer;
  }
</style>




// WEBPACK FOOTER //
// Hello-World.vue?71cb0095